<template>
    <div id="category-slider" class="flex flex-row overflow-x-scroll overflow-y-hidden" v-if="catList">
        <div class="flex-1 font-main font-medium text-12 whitespace-nowrap" v-for="(cat, k) in catList" :key="k">
            <template v-if="!isLastTab(k) || userGrade == null">
                <div class="menu-title text-center px-3.5 py-3 cursor-pointer border-b-2 border-a-orange-fe5000 text-a-orange-fe5000"
                    v-if="k == activeIndex">
                    {{ catName(cat) }}
                </div>
                <div class="menu-title text-center px-3.5 py-3 cursor-pointer border-b border-a-black-484848 text-a-black-484848"
                    v-else @click="clickTab(k)">
                    {{ catName(cat) }}
                </div>
            </template>
            <template v-else>
                <div class="menu-title text-center user-grade py-3 rounded-10 text-white cursor-pointer"
                    :class="userGradeClass" @click="clickTab(k)">
                    {{ catName(cat) }}
                </div>
            </template>
        </div>
    </div>
</template>
<script>
import { UserGrades } from '@/helper/StaticValue';
import Util from '@/helper/Utility.js';
import LocaleMixin from '@/mixin/LocaleMixin.js';

export default {
    name: 'CatSlider',
    mixins: [LocaleMixin],
    inject: ["AccountStore"],
    props: {
        catList: { type: Array, required: true },
    },
    data: function () {
        return {
            activeIndex: 0,
            slide: {
                isDown: false,
                startX: 0,
                scrollLeft: 0,
            },
        };
    },
    computed: {
        userGrade: function () {
            let displayGrade = [UserGrades.Gold, UserGrades.RoseGold, UserGrades.Silver]
            let uGrade = this.AccountStore.state.userGrade

            // if user grade is not U, E, P then display as null
            if (!Util.isEmptyStr(uGrade) && displayGrade.indexOf(uGrade) == -1) {
                return null
            }
            return uGrade
        },
        userGradeClass: function () {
            if (this.userGrade == UserGrades.Gold) {
                return "u-gold"
            } else if (this.userGrade == UserGrades.RoseGold) {
                return "e-rose-gold"
            } else {
                return "p-silver"
            }
        }
    },
    created: function () {
        if (this.$route.params.catId) {
            this.setDefaultTab();
        } else {
            this.$router.replace('/privilege/' + this.catList[0].id)
        }
    },
    methods: {
        setDefaultTab: function () {
            let catId = this.$route.params.catId;

            if (!Util.isEmptyStr(catId)) {
                if (catId == 'foryou') {
                    this.activeIndex = 3
                } else {
                    for (let i in this.catList) {
                        if (this.catList[i].id == catId) {
                            this.activeIndex = i;
                            break;
                        }
                    }
                }
                this.clickTab(this.activeIndex);
                // this.$router.push('/privilege/' + this.catList[this.activeIndex].id)
            }
        },
        catName: function (cat) {
            return this.localeCode == 1033 ? cat.nameEn : cat.nameTh;
        },
        clickTab: function (index) {
            this.$router.push('/privilege/' + this.catList[index].id)
            if (index == null) {
                index = 0
            }
            this.activeIndex = index;
            let send = {
                index: index,
                cat: this.catList[index],
            };
            this.$emit('clickTab', send);
        },
        isLastTab: function (idx) {
            return this.catList.length - 1 == idx
        }
    },
}
</script>
<style lang="scss" scoped>
@import "@/style/base/text.scss";

#category-slider {
    &::-webkit-scrollbar {
        display: none;
    }

    .menu-title {
        @extend %ellipsis-2;
    }

    .user-grade {
        &.p-silver {
            background-image: linear-gradient(to bottom, #737373, #fff 16%, #737373 56%, #d0d0d0);
        }

        &.e-rose-gold {
            background-image: linear-gradient(to bottom, #8d4b30, #ffd4c9 16%, #8d4b30 56%, #e1a091);
        }

        &.u-gold {
            background-image: linear-gradient(to bottom, #785520, #fff0b9 16%, #785520 56%, #e1c88c);
        }
    }
}
</style>
